export const DATE_RANGE_OPTIONS = [
  { value: "", label: "All time" },
  { value: "today", label: "Today" },
  { value: "7d", label: "Last 7 Days" },
  { value: "30d", label: "Last 30 Days" },
  { value: "90d", label: "Last 90 Days" },
  { value: "custom", label: "Custom" },
];

function toLocalDateKey(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

export function resolveDateRangeFilter(preset = "", customFrom = "", customTo = "") {
  const today = new Date();
  const dateTo = toLocalDateKey(today);

  if (preset === "today") {
    return { date_from: dateTo, date_to: dateTo };
  }

  if (preset === "7d" || preset === "30d" || preset === "90d") {
    const start = new Date(today);
    const days = preset === "7d" ? 6 : preset === "30d" ? 29 : 89;
    start.setDate(today.getDate() - days);

    return {
      date_from: toLocalDateKey(start),
      date_to: dateTo,
    };
  }

  if (preset === "custom") {
    return {
      date_from: customFrom || null,
      date_to: customTo || null,
    };
  }

  return {
    date_from: null,
    date_to: null,
  };
}
